import IAdvanceGeneralGameConfig from '../../vendor_core/core/src/managers/contracts/configurations/game/IAdvanceGeneralGameConfig';
import ISymbolTypeGameConfig from '../../vendor_core/core/src/managers/contracts/configurations/game/ISymbolTypeGameConfig';
import IVendorClientConfigRequestData from '../../vendor_core/server/requests/contracts/IVendorClientConfigRequestData';
import AbstractVendorGameGeneralConfig from '../../vendor_core/vendorConfigs/AbstractVendorGameGeneralConfig';

class GameGeneralConfig extends AbstractVendorGameGeneralConfig implements IAdvanceGeneralGameConfig<IVendorClientConfigRequestData> {
    symbolType: ISymbolTypeGameConfig = {
        spine: true,
        standard: false,
        symbol3D: false
    };
}

export default new GameGeneralConfig()
